module.exports = __webpack_public_path__ + "static/media/airLamp_hero.cad1f328.png";